import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Import jwt-decode

const Menu = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    // --- NEW: State to hold the full user object, including their role ---
    const [user, setUser] = useState(null);

    // This effect runs when the menu is opened to check the user's login status and role.
    useEffect(() => {
        if (isOpen) {
            const token = localStorage.getItem('app_token');
            if (token) {
                try {
                    // Decode the token to get the user's details and role
                    const decodedUser = jwtDecode(token);
                    setUser(decodedUser);
                } catch (error) {
                    console.error("Invalid token:", error);
                    setUser(null); // Clear user state if token is bad
                }
            } else {
                setUser(null); // Ensure user is null if no token exists
            }
        }
    }, [isOpen]);

    // This function handles the logout process.
    const handleLogout = () => {
        localStorage.removeItem('app_token'); // Remove the token from storage
        setUser(null); // Clear the user state
        onClose(); // Close the menu
        navigate('/', { state: { message: 'Logout successful!' } }); // Redirect with a message
    };
    // Don't render the menu if it's not open.
    if (!isOpen) {
        return null;
    }

    return (
        <div className="menu-overlay">
            <button onClick={onClose} className="menu-close-button">
                <span className="material-icons">close</span>
            </button>
            <nav className="menu-nav">
                {/* These links are always visible */}
                <Link to="/profile" className="menu-link" onClick={onClose}>About Me</Link>
                <Link to="/marathon-profile" className="menu-link" onClick={onClose}>Marathon Diaries</Link>
                <Link to="/settings" className="menu-link" onClick={onClose}>Settings</Link>

                {/* AI Chat - only for logged-in users */}
                {user && (
                    <Link to="/ai-chat" className="menu-link" onClick={onClose}>
                        AI Assistant
                    </Link>
                )}

                {/* Courses - only for admin users */}
                {user && user.role === 'admin' && (
                    <Link to="/courses" className="menu-link" onClick={onClose}>
                        Courses
                    </Link>
                )}

                {/* --- NEW: Conditionally render the Admin Panel link --- */}
                {user && user.role === 'admin' && (
                    <Link to="/admin" className="menu-link" onClick={onClose}>
                        Admin Panel
                    </Link>
                )}

                {/* --- NEW: Book Preview link for admins, reviewers, or specific emails --- */}
                {user && (user.role === 'admin' || user.role === 'reviewer' || user.email === 'singhpuru06@gmail.com' || user.email === 'hemantjha28@gmail.com') && (
                    <Link to="/book-preview" className="menu-link" onClick={onClose}>
                        Book Preview
                    </Link>
                )}

                {/* This section now changes based on whether the user is logged in */}
                {user ? (
                    <button onClick={handleLogout} className="menu-link as-button">Logout</button>
                ) : (
                    <Link to="/login" className="menu-link" onClick={onClose}>Login</Link>
                )}
            </nav>
        </div>
    );
};

export default Menu;
